import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import PlusSign from '@/images/PlusSign.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const CreateButton = styled.div`
    background-color: white;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};

    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    gap: 12px;

    color: ${({ theme }) => theme.colors.black.main};
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.4px;

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        background-color: ${({ theme }) => theme.colors.black[100]};
    }

    :hover {
        border: 1px solid ${({ theme }) => theme.colors.secondary[900]};
        box-shadow:
            0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.11),
            0.5px 1.3px 1.8px -0.6px rgba(187, 187, 187, 0.18),
            1.1px 2.7px 3.8px -1.2px rgba(187, 187, 187, 0.26);
    }
`;

interface Props {
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    label: string;
    className?: string;
    loading?: boolean;
    id: string;
    testId?: string;
}

export const AddLibraryItemCard = ({ onClick, label, className, loading, id, testId }: Props) => {
    const theme = useTheme();

    return (
        <CreateButton onClick={onClick} className={className} id={id} data-testid={testId}>
            {loading ? (
                <CircularProgress />
            ) : (
                <>
                    <div>
                        <MaskedIcon src={PlusSign} color={theme.colors.secondary[900]} size="36px" />
                    </div>
                    {label}
                </>
            )}
        </CreateButton>
    );
};
